RivalIQ.module('landscape.views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const newLandscapeSteps = [
        {
            title: 'Step 1: Name New Landscape',
            titleInfoBubble: null,
            stepText: 'Next, add companies',
            stepClassName: 'btn-primary',
            body: Marionette.ItemView.extend({
                tagName: 'form',
                ui: {
                    input: 'input'
                },
                attributes: {
                    style: 'display: flex;'
                },
                events: {
                    'keypress input': 'onKeypress'
                },
                className: 'form-horizontal',
                template: '#newLandscapeNameTemplate',
                satisfied: function () {
                    const me = this;
                    const size = _.size(me.getState().name);
                    return (size > 0 && size < 101);
                },
                onShown: function () {
                    const me = this;

                    me.ui.input.focus();
                    RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ViewedLandscapeModal, me.getOption('trackingOptions'));
                },
                getState: function () {
                    const me = this;
                    const name = _.trimEnd(me.ui.input.val());
                    return {
                        name: name
                    };
                },
                onKeypress: function (e) {
                    const me = this;
                    if (e.keyCode === 13) {
                        me.trigger('step');
                        return false;
                    }
                },
                transition: function () {
                    const me = this;
                    return $.when({
                        landscapeModel: new RivalIQ.models.Landscape({
                            name: me.getState().name
                        })
                    });
                }
            })
        },
        {
            title: 'Step 2: Add Companies to Your Landscape',
            titleInfoBubble: RivalIQ.strings.company_add_tooltip,
            stepText: 'Create landscape',
            stepClassName: 'btn-default btn-disabled',
            body: views.CompanyAdd.extend({
                createLandscape: true,
                template: '#newLandscapeCompaniesTemplate',
                initialize: function () {
                    const me = this;
                    views.CompanyAdd.prototype.initialize.apply(me, arguments);
                    me.landscapeModel = me.model.get('landscapeModel');
                    me.listenTo(RivalIQ.state.account, 'change:companyLimits', me.updateQuotaMessage);
                },
                onRenderLoaded: function () {
                    const me = this;
                    me.updateQuotaMessage();
                    me.modalHelpers.setStepDisabledState(true);
                    me.requestRenderedFrame(function () {
                        me.ui.domainInput.focus();
                        me.$el.closest('.modal-content').find('[data-toggle="popover"]').popover();
                    });
                },
                satisfied: function () {
                    const me = this;
                    me.persisted = true;
                    $.ajax({
                        type: 'PUT',
                        url: `/api/setActiveLandscape/${me.landscapeModel.id}`
                    })
                        .done(function () {
                            // NOTE: intentionally sending users to the companies page instead of defaultRedirectLocation. See #27137
                            window.location = '/companies';
                        });
                },
                onLandscapeCreated: function () {
                    const me = this;

                    RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.CreatedLandscape, me.getOption('trackingOptions'));
                    me.modalHelpers.setStepDisabledState(false);
                    me.modalHelpers.setStepClassName('btn-primary');
                    me.modalHelpers.setStepAttributes({
                        'data-dismiss': 'modal'
                    });
                },
                // NOTE required when errors occur adding a company
                enableDoneButton: _.noop,
                updateQuotaMessage: function () {
                    const me = this;

                    let message;
                    const companyLimits = RivalIQ.state.account.get('landscapeCompanyLimits');
                    if (companyLimits) {
                        let templateSelector = '#companyQuotaMessage';

                        // NOTE companyLimits.credits is assigned to null when
                        // company limits are not enforced
                        const credits = _.get(companyLimits, ['credits']) || {};

                        if (credits.distinct >= credits.plan) {
                            templateSelector = '#companyQuotaWarningMessage';
                        }

                        const data = {
                            companyLimits: companyLimits
                        };
                        const template = Marionette.TemplateCache.get(templateSelector);
                        message = template(data);
                    }

                    me.modalHelpers.renderMessage(message);
                }
            })
        }
    ];

    const NewLandscapeModalBody = views.BaseStepModalBody.extend({
        template: '#newLandscapeModalTemplate',
        templateFields: [
            'title',
            'stepText',
            'stepClassName',
            'modalBodyClass',
            'titleInfoBubble'
        ],
        steps: newLandscapeSteps,

        ui: {
            step: '.x-step',
            cancelBtn: '.x-cancel-btn',
            message: '.x-quota-message'
        },

        showStep: function () {
            const me = this;

            const Body = me.getStep().get('body');
            const view = _.extend(new Body({
                model: me.model,
                trackingOptions: me.getOption('trackingOptions')
            }), {
                modalHelpers: {
                    setStepAttributes: function (attrs) {
                        me.ui.step.attr(attrs);
                    },
                    setStepClassName: function (className) {
                        let cls = className;
                        if (_.isArray(className)) {
                            cls = className.join(' ');
                        }
                        me.ui.step.addClass(cls);
                    },
                    setStepDisabledState: function (disabled) {
                        me.ui.step.toggleClass?.('btn-disabled', disabled);
                        me.ui.step.prop?.('disabled', disabled);
                    },
                    renderMessage: function (message) {
                        if (message) {
                            me.ui.message.html(message);
                        } else {
                            me.ui.message.empty();
                        }
                    }
                }
            });

            me.listenTo(view, 'step', me.onStepClick);

            me.body.show(view);
        },

        modalBodyClass: 'x-company-add-modal-body x-company-landscape-add-modal',
        onStepClick: function () {
            const me = this;
            const view = me.body.currentView;
            if (view.satisfied()) {
                view.transition().done(function (state) {
                    me.model.set(
                        _.defaults({
                            step: me.model.get('step') + 1
                        }, _.defaults({}, view.getState(), state))
                    );
                });
            }
        },

        onRender: function () {
            const me = this;

            views.BaseStepModalBody.prototype.onRender.call(me, arguments);
            me.ui.cancelBtn.hide();
        }
    });

    views.NewLandscapeModal = views.BaseStepModal.extend({
        modalBody: NewLandscapeModalBody,

        onHidden: function () {
            const me = this;
            const modal = me.content.currentView;
            const step = modal.body.currentView;

            if (!step.persisted) {
                const landscapeModel = step.model.get('landscapeModel');
                if (landscapeModel) {
                    landscapeModel.destroy();
                }
            }
        }
    });

    views.CompanyLandscapeAddModal = views.CompanyAdd.extend({
        ui: _.extend({}, views.CompanyAdd.prototype.ui, {
            modal: '.modal',
            modalContent: '.modal-content',
            modalBody: '.modal-body',
            modalDialog: '.modal-dialog',
            modalHeader: '.modal-header',
            modalFooter: '.modal-footer',
            domainContainer: '.x-domain-container',
            landscapeNameFormGroup: '.form-group.x-landscape-name',
            landscapeInput: '.x-landscape-input',
            doneButton: 'button.x-done',
            saveLandscapeButton: '.x-save-landscape-name',
            landscapeNameStatus: '.x-landscape-name-status',
            errorContainer: '.x-error-msg-container',
            errorMsg: '.x-error-msg-container .x-msg',
            completeButton: '.x-complete-button',
            quotaMessage: '.x-quota-message',
            inlineOverLimitForLandscape: '.x-container.x-inline-over-limit-for-landscape'
        }),
        // we need to do this dance to extend the events that are set on the parent class
        events: _.extend({}, views.CompanyAdd.prototype.events, {
            'shown.bs.modal': 'onShown',
            'hidden.bs.modal': 'onHidden',
            'click .x-save-landscape-name': 'clickLandscapeName',
            'keypress .x-landscape-input': 'onKeypressLandscape'
        }),
        className: 'x-company-landscape-add-modal',
        template: '#landscapeAddModalTemplate',

        initialize: function () {
            const me = this;
            views.CompanyAdd.prototype.initialize.apply(me, arguments);
            me.listenTo(RivalIQ.state.account, 'change:companyLimits', me.updateQuotaMessage);
        },

        templateHelpers: function () {

            const me = this;

            const result = {
                createLandscape: me.createLandscape
            };

            return result;
        },

        onError: function (msg) {
            this.ui.errorMsg.html(msg);
            this.ui.errorContainer.show();
        },

        onRenderLoaded: function () {
            const me = this;
            const landscapeCompanyLimits = RivalIQ.state.account.get('landscapeCompanyLimits');
            const isCreateLandscape = me.getOption('createLandscape');
            const excludedCompanyIds = _.get(RivalIQ.state.landscape.get('auditSettings'), 'excludedCompanyIds', []);
            const companyIds = RivalIQ.state.landscape.get('companies').pluck('id');
            const companies = _.size(_.reject(companyIds, function (val) {
                return _.includes(excludedCompanyIds, val);
            }));
            const isAtLandscapeCompanyLimit = (companies >= landscapeCompanyLimits.landscape);

            me.ui.modal.modal();
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ClickedAddCompanies);

            if (isCreateLandscape) {
                me.landscapeModel = new RivalIQ.models.Landscape();
                me.ui.landscapeInput.focus();
                me.ui.domainInput.prop('disabled', true);
                me.ui.companyAddButton.prop('disabled', true);
            } else if (isAtLandscapeCompanyLimit) {
                me.onOverLimit({
                    isInitialRender: false,
                    type: RivalIQ.landscape.enums.overLimitErrorTypes.TooManyCompaniesInLandscapeError
                });
            } else {
                me.ui.domainInput.focus();
            }

            me.updateQuotaMessage();
        },

        clickLandscapeName: function () {

            const me = this;
            const name = $.trim(me.ui.landscapeInput.val());

            me.landscapeModel.set('name', name);

            me.ui.landscapeNameFormGroup.removeClass('has-error');
            me.ui.landscapeNameStatus.empty();

            const MAX_NAME_LENGTH = 100;
            if (!name || name.length > MAX_NAME_LENGTH) {
                me.ui.landscapeNameFormGroup.addClass('has-error');
                me.ui.landscapeNameStatus.html('Landscape name is required, and must be 100 characters or less.');
                me.ui.landscapeNameStatus.fadeIn(100);
                return false;
            }

            me.ui.saveLandscapeButton.addClass('fade invisible');
            me.ui.landscapeNameStatus.html('Name saved.');
            me.ui.landscapeNameStatus.fadeIn(100);
            me.ui.domainInput.prop('disabled', false);
            me.ui.companyAddButton.prop('disabled', false);
            me.ui.landscapeInput.prop('disabled', true);
            me.ui.domainInput.focus();
            // we aren't going to persist this to the server yet because we want to add at least one company first
        },

        onKeypressLandscape: function (e) {

            const me = this;

            if (e.keyCode === 13) {
                me.clickLandscapeName();
                return false;
            }
        },

        onHidden: function () {

            const me = this;
            const landscapeModel = me.landscapeModel;

            if (me.createLandscape && landscapeModel && landscapeModel.id) {

                RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.CreatedLandscape);
                RivalIQ.execute('landscape:load', landscapeModel.id, RivalIQ.state.product.get('defaultRedirectLocation'));
            }
        },

        onShown: function () {

            const me = this;
            const isCreateLandscape = me.getOption('createLandscape');

            if (isCreateLandscape) {

                me.ui.landscapeInput.focus();
            } else {

                me.ui.domainInput.focus();
            }

            me.$el.find('[data-toggle="popover"]').popover();
        },

        enableDoneButton: function () {

            this.ui.doneButton.prop('disabled', false);
        },

        updateQuotaMessage: function () {
            const me = this;
            const companyLimits = RivalIQ.state.account.get('landscapeCompanyLimits');

            me.requestRenderedFrame(function () {
                if (companyLimits) {
                    let templateSelector = '#companyQuotaMessage';

                    // NOTE companyLimits.credits is assigned to null when
                    // company limits are not enforced
                    const credits = (_.get(companyLimits, 'credits') || {});

                    if (credits.distinct >= credits.plan) {
                        templateSelector = '#companyQuotaWarningMessage';
                    }

                    const data = {
                        companyLimits: companyLimits
                    };
                    const template = Marionette.TemplateCache.get(templateSelector);
                    me.ui.quotaMessage.html(template(data));
                } else {
                    me.ui.quotaMessage.empty();
                }
            });
        },

        createOverLimitModal: function (overLimitErrorType, viewConstructorArg) {
            const me = this;

            // too many companies in landscape
            const modal = new views.OverLandscapeSizeLimitModal(viewConstructorArg);

            // NOTE we need to listen to the dismiss event to make sure that the
            // parent modal (this) is hidden appropriately
            me.listenTo(modal, 'dismiss', function () {
                me.ui.modal.modal('hide');
            });

            return modal;
        },

        onOverLimit: function (options) {
            const me = this;
            const overLimitErrorType = options.type;

            // do tracking
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.AddModalHitLimit);

            // NOTE we want to make sure that if this is not the first render we show a different kind of limit paywall
            // than we do in the typical company add (where we wipe the body), so the user can save their landscape
            const isCreateLandscape = me.getOption('createLandscape');
            if (isCreateLandscape && !options.isInitialRender) {
                // first wait a bit, then hide and show
                setTimeout(function () {
                    me.ui.domainContainer.fadeOut(250, function () {
                        const messageTemplate = `#overLimit${overLimitErrorType.name}Message`;
                        const template = Marionette.TemplateCache.get(messageTemplate);
                        me.ui.inlineOverLimitForLandscape.html(template(options.data));
                        me.ui.inlineOverLimitForLandscape.fadeIn(250);
                        me.ui.completeButton.html('Activate My Landscape');
                    });
                }, 100);
            } else {
                const companyLimits = RivalIQ.state.account.get('landscapeCompanyLimits');
                me.ui.modalHeader.hide();
                me.ui.modalFooter.hide();
                me.ui.modalDialog.addClass('modal-lg');
                me.createOverLimitModal(overLimitErrorType, {
                    el: me.ui.modalContent,
                    modal: me.ui.modal,
                    model: new Backbone.Model(_.defaults({
                        companyLimits: companyLimits,
                        overLimitErrorType: overLimitErrorType
                    }, options.data))
                }).render();
            }
        }
    });

});
